import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/auth-store';
import { notificationsApi } from '../api';
import { notificationsQueryKey } from './queryKey';

const POLL_INTERVAL_MS = 60_000;

export function useNotifications() {
  const { status, user } = useAuth();
  return useQuery({
    queryKey: notificationsQueryKey(user?.id),
    queryFn: notificationsApi.list,
    enabled: status === 'authed' && user != null,
    staleTime: 30_000,
    refetchInterval: POLL_INTERVAL_MS,
  });
}
